<btw-dialog-body>
    <div class="btw-row">
        <div class="btw-col-12">
            <btw-table [data]="bankStatementsDailyDrillDown" [pageSize]="pageSize">
                <btw-text-search placeholder="Unesite tekst..." position="left">
                </btw-text-search>
                <btw-table-column dataField="date" caption="Datum" className="date" dataType="date" [sortIndex]="0"
                    sortOrder="desc"></btw-table-column>
                <btw-table-column dataField="nameOfCounterparty" caption="Naziv" dataType="string"
                    [sortIndex]="0"></btw-table-column>
                <btw-table-column dataField="amount" caption="Iznos" [template]="amount">
                    <ng-template #amount let-row="row">
                        <span [ngClass]="row.credit ? 'credit-color' : 'debit-color'">{{getAmount(row)}}</span>
                    </ng-template>
                </btw-table-column>
                <btw-table-column dataField="paymentDescription" caption="Opis" dataType="string"
                    [sortIndex]="0"></btw-table-column>
                <btw-table-column dataField="accountOfCounterparty" caption="Racun" dataType="string"
                    [sortIndex]="0"></btw-table-column>
            </btw-table>
        </div>
    </div>
</btw-dialog-body>